import React, { FC } from 'react';
import classNames from 'classnames';
import { Form as NativeForm } from '@tarojs/components';
import { FormProps } from '@tarojs/components/types/Form';

interface IFormProps extends FormProps {
  className?: string;
}

const Form: FC<IFormProps> = ({ className = '', children, ...resetProps }) => {
  const rootCls = classNames('ink-form', className);
  return (
    <NativeForm className={rootCls} {...resetProps}>
      {children}
    </NativeForm>
  );
};

export default Form;
